// extracted by mini-css-extract-plugin
export default {"liveFixtureLeague":"LiveFixture_liveFixtureLeague__oI6uT","liveScoreFixture":"LiveFixture_liveScoreFixture__BVB9R","teamStyles":"LiveFixture_teamStyles__nhp2T"};